function get_onerror_fun(collector_url)
{
  return function (message, url, line, col, error, ...rest)
  {
    //console.error('ERROR', message, url, line, col, error, rest); // eslint-disable-line no-console
    if (message && typeof message === 'string' && message.includes('ResizeObserver loop')) {
      return true;
    }
    var xhr = new XMLHttpRequest();
    xhr.open('POST', collector_url, true);
    xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
    var UA = String(navigator.userAgent);
    var lang = String(navigator.language);
    var langs = String(navigator.languages);
    var page_url = location.href;
    var error_report = '';
    if (error) 
    {
      if (error.stack)
      {
        error_report = String(error.stack);
      }
      else
      {
        error_report = String(error);
      }
    }
    var mesg = '\n\n' + url + ':' + line + ':' + col + ' \n' + message;
    xhr.onreadystatechange = function ()
    {
      if (xhr.readyState === 4)
      {
        if (xhr.status === 200)
        {
          alert('An error has occured, it has been reported.\nWystąpił błąd, raport został wysłany.' + mesg);
          if (console.error) // eslint-disable-line no-console
          {
            console.error([message, url, line, col, error]); // eslint-disable-line no-console
          }
        }
        else
        {
          alert('An error has occured, it has not been reported, status: ' +
            xhr.status + '\nWystąpił błąd, raport nie został poprawnie wysłany, status: ' +
            xhr.status +
            mesg);
        }
      }
    };
    var data = 'url=' + encodeURIComponent(String(url))
      + '&line=' + encodeURIComponent(String(line))
      + '&col=' + encodeURIComponent(String(col))
      + '&message=' + encodeURIComponent(String(message))
      + '&error=' + encodeURIComponent(String(error_report))
      + '&UA=' + encodeURIComponent(String(UA))
      + '&page_url=' + encodeURIComponent(String(page_url))
      + '&lang=' + encodeURIComponent(String(lang))
      + '&langs=' + encodeURIComponent(String(langs))
      + '&rest=' + encodeURIComponent(String(rest));
    xhr.send(data);
    return true;
  }
}

function setup_onerror(collector_url)
{
  if (import.meta.env.PROD)
  {
    if (window)
    {
      window.onerror = get_onerror_fun(collector_url);
    }
  }
}

function setup_vueonerror(collector_url, app)
{
  if (import.meta.env.PROD)
  {
    let onerror_fun = get_onerror_fun(collector_url);
    app.config.errorHandler = function (error, component, info)
    {
      if (error.message && error.message.includes('ResizeObserver loop')) {
        return;
      }
      console.error([error, info]); // eslint-disable-line no-console
      onerror_fun(error.message, '', 0, 0, error, info);
    }
  }
}

export { setup_onerror, setup_vueonerror };
